import React from 'react';

// A <select> that shows a spinner and a disabled "Loading..." option while its
// options are being fetched. Accepts every prop a <select> does, plus:
// loading: boolean, true while the options are still loading
const LoadingSelect = (props) => {
    const { loading, children, style, ...selectProps } = props;

    if (!loading) {
        return <select style={style} {...selectProps}>{children}</select>;
    }

    return (
        <div style={{ position: "relative" }}>
            <select {...selectProps} value="" disabled aria-busy="true" style={style}>
                <option value="">Loading...</option>
            </select>
            <span
                className="spinner-border spinner-border-sm text-secondary"
                role="status"
                aria-label="Loading"
                style={{ position: "absolute", top: "50%", right: "2.5rem", marginTop: "-0.5rem", pointerEvents: "none" }}
            />
        </div>
    );
}
export default LoadingSelect;
